export default "__VITE_ASSET__16hINC4D__"